

































import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Subscription } from 'rxjs';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { DiscountRuleInput } from '@accounting/interfaces/discount-rule-input';

@Component({
  name: 'bpc-discount-rule',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-std-form': StdForm,
  },
})
export default class DiscountRule extends mixins(AbstractField) {
  @Prop({
    type: Object,
    default() {
      return { entity: null, rule: null, conditions: {} };
    },
  })
  readonly value: DiscountRuleInput;

  mounted() {
    this.model = this.value || { entity: null, rule: null, conditions: {} };
    if (this.model.entity) {
      this.presetDataToInitialize = JSON.parse(JSON.stringify(this.model.conditions));
      this.loadDiscountRules(this.model.entity);
    }
  }

  model: DiscountRuleInput = { entity: null, rule: null, conditions: {} };
  presetDataToInitialize: DiscountRuleInput = null;
  entityName: string = null;
  loadingRuleOptions: boolean = false;
  ruleOptionsSubscription: Subscription;
  ruleOptions = [];
  ruleFormConfigName: string = null;

  extendHandleEvent(eventName: string, event: any, val: any) {
    switch (event.action) {
      case 'loadDiscountRules':
        this.resetDiscountComponent();
        this.loadDiscountRules(val);
        break;
    }
  }

  onChangeRule(rule) {
    this.resetRuleConditionsForm();

    const ruleOption = this.ruleOptions.find(item => item.value === rule);
    if (ruleOption) {
      this.ruleFormConfigName = ruleOption.form;
      this.model.entity = ruleOption.entity;
    }
    this.$emit('change', this.model);
  }

  resetDiscountComponent() {
    this.model = { entity: null, rule: null, conditions: {} };
    this.presetDataToInitialize = null;
    this.ruleFormConfigName = null;
  }

  resetRuleConditionsForm() {
    this.model.conditions = {};
    this.presetDataToInitialize = null;
    this.ruleFormConfigName = null;
  }

  loadDiscountRules(applyTo) {
    if (applyTo === 'global') {
      this.entityName = null;
    } else {
      this.entityName = applyTo;
    }

    if (this.entityName) {
      this.getRulesFromConfig(this.entityName);
    }
  }

  getRulesFromConfig(entityName) {
    this.loadingRuleOptions = true;

    if (this.ruleOptionsSubscription) {
      this.ruleOptionsSubscription.unsubscribe();
    }
    this.ruleOptionsSubscription = this.$bpcConfig
      .getEntityConfig(`${entityName}.discounts`)
      .subscribe(
        res => {
          this.ruleOptions = res.data.rules;
        },
        error => {
          console.log(error);
        },
        () => {
          this.loadingRuleOptions = false;
          // If a rule is selected before load its, we set the formConfigName to load the form
          const ruleOption = this.ruleOptions.find(item => item.value === this.model?.rule);
          if (ruleOption) {
            this.ruleFormConfigName = ruleOption.form;
          }
        },
      );
  }

  get modelRule() {
    return this.model.rule;
  }

  get modelConditions() {
    return this.model.conditions;
  }

  @Watch('value')
  onValueChange() {
    this.model = this.value;
  }

  @Watch('modelRule')
  onModelRuleChange() {
    this.$emit('input', this.model);
  }

  @Watch('modelConditions', { deep: true })
  onModelConditionsChange() {
    this.$emit('input', this.model);
  }
}
